import { useEffect, useRef } from 'react';
import { Modal, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGear } from '@fortawesome/free-solid-svg-icons';
// import useKeyPress from '../../services/Controls/useKeyPress';
import { useToggle } from '../../services/General/useToggle';
import { SettingsPageBody } from './SettingsPageBody';
//import { SettingsPageList } from './SettingsPageList';
import { useDrivingMethod, DrivingTypes } from '../../services/Ros/Driving/DrivingProvider';
//import { MissionPlanOverview } from './MissionPlanOverview';
import '../../css/StreamSelector.css';  // Import the CSS file
import '../../css/path-planning.css'; 


export const SettingsPageOverlay = () => {

    const [show, setShow] = useToggle(false);
    const { control, setDisabled } = useDrivingMethod();
    const drivingMethod = useRef<DrivingTypes>(control);


    useEffect(() => {
        if(show === true){
            console.log("Disabling Driving While Settings is up.");
            drivingMethod.current = control;
            setDisabled(true);
        } else {
            console.log("Setting method back to what it was. ", drivingMethod.current);
            setDisabled(false);
        }
    },[show]);

    // useKeyPress('p', setShow);


    const render = () => {
        //const {state : {data, status}} = fetchMissionPlans;
        return <SettingsPageBody />;
    }


    return (
        <>
            <OverlayTrigger placement="bottom" overlay={<Tooltip id="settings-tooltip">Settings</Tooltip>}>
                <Button
                    variant='info'
                    size="lg"
                    onClick={setShow}
                    className={show ? "button.selected" : "button"}
                >
                    <FontAwesomeIcon icon={faUserGear} inverse={true} size="lg" />
                </Button>
            </OverlayTrigger>
            <Modal 
                fullscreen='lg-down' 
                className='path-planning-modal' 
                dialogClassName='modal-90w overflow-hidden' 
                size='xl' 
                centered 
                show={show} 
                onHide={setShow} >
                <Modal.Header closeButton>
                    <Modal.Title className='text-dark'>Settings</Modal.Title>
                </Modal.Header>
                <Modal.Body className='ps-0 pb-0 pt-0'>
                    {render()}
                </Modal.Body>
            </Modal>
        </>
    );
}